import { render } from "./DefSelectWrapper.vue?vue&type=template&id=f95fd312&scoped=true"
import script from "./DefSelectWrapper.vue?vue&type=script&lang=js"
export * from "./DefSelectWrapper.vue?vue&type=script&lang=js"

import "./DefSelectWrapper.vue?vue&type=style&index=0&id=f95fd312&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f95fd312"]])

export default __exports__